const FALLBACK_LOCALE = "sv";
export const RELATIVE_STRINGS = {
    loading: {
        sv: "Ansluter…",
        en: "Connecting…",
        no: "Kobler til…",
        da: "Forbinder…",
        fi: "Yhdistetään…",
    },
    connected_to: {
        sv: "Du är kopplad till {name} rum",
        en: "You are connected to {name}'s room",
        no: "Du er koblet til {name} rom",
        da: "Du er forbundet til {name} stue",
        fi: "Sinut on yhdistetty huoneeseen: {name}",
    },
    connected_to_generic: {
        sv: "Du är kopplad till rummet",
        en: "You are connected to the room",
        no: "Du er koblet til rommet",
        da: "Du er forbundet til stuen",
        fi: "Sinut on yhdistetty huoneeseen",
    },
    waiting_hint: {
        sv: "Håll den här sidan öppen. När rummet ringer syns samtalet här.",
        en: "Keep this page open. When the room calls, it will appear here.",
        no: "Hold denne siden åpen. Når rommet ringer, vises samtalet her.",
        da: "Hold denne side åben. Når stuen ringer, vises opkaldet her.",
        fi: "Pidä tämä sivu auki. Kun huoneesta soitetaan, puhelu näkyy tässä.",
    },
    call_room: {
        sv: "Ring rummet",
        en: "Call the room",
        no: "Ring rommet",
        da: "Ring til stuen",
        fi: "Soita huoneeseen",
    },
    call_room_calling: {
        sv: "Ringer…",
        en: "Calling…",
        no: "Ringer…",
        da: "Ringer…",
        fi: "Soitetaan…",
    },
    call_room_failed: {
        sv: "Det gick inte att ringa just nu. Försök igen.",
        en: "The call could not be placed right now. Please try again.",
        no: "Det gikk ikke å ringe akkurat nå. Prøv igjen.",
        da: "Opkaldet kunne ikke gennemføres lige nu. Prøv igen.",
        fi: "Puhelua ei voitu soittaa juuri nyt. Yritä uudelleen.",
    },
    incoming: {
        sv: "Inkommande videosamtal",
        en: "Incoming video call",
        no: "Innkommende videosamtal",
        da: "Indgående videoopkald",
        fi: "Saapuva videopuhelu",
    },
    answer: { sv: "Svara", en: "Answer", no: "Svar", da: "Besvar", fi: "Vastaa" },
    decline: {
        sv: "Avböj",
        en: "Decline",
        no: "Avvis",
        da: "Afvis",
        fi: "Hylkää",
    },
    connecting_to: {
        sv: "Ansluter till {name}…",
        en: "Connecting to {name}…",
        no: "Kobler til {name}…",
        da: "Forbinder til {name}…",
        fi: "Yhdistetään: {name}…",
    },
    reconnecting: {
        sv: "Återansluter…",
        en: "Reconnecting…",
        no: "Kobler til igjen…",
        da: "Genopretter forbindelse…",
        fi: "Yhdistetään uudelleen…",
    },
    mic_on: {
        sv: "Stäng av mikrofon",
        en: "Mute microphone",
        no: "Slå av mikrofon",
        da: "Sluk mikrofon",
        fi: "Mykistä mikrofoni",
    },
    mic_off: {
        sv: "Slå på mikrofon",
        en: "Unmute microphone",
        no: "Slå på mikrofon",
        da: "Tænd mikrofon",
        fi: "Poista mykistys",
    },
    cam_on: {
        sv: "Stäng av kamera",
        en: "Turn off camera",
        no: "Slå av kamera",
        da: "Sluk kamera",
        fi: "Sammuta kamera",
    },
    cam_off: {
        sv: "Slå på kamera",
        en: "Turn on camera",
        no: "Slå på kamera",
        da: "Tænd kamera",
        fi: "Käynnistä kamera",
    },
    hang_up: {
        sv: "Avsluta",
        en: "Hang up",
        no: "Legg på",
        da: "Læg på",
        fi: "Lopeta",
    },
    camera_live: {
        sv: "Kamera på",
        en: "Camera on",
        no: "Kamera på",
        da: "Kamera til",
        fi: "Kamera päällä",
    },
    call_ended: {
        sv: "Samtalet avslutades",
        en: "The call ended",
        no: "Samtalet ble avsluttet",
        da: "Opkaldet er afsluttet",
        fi: "Puhelu päättyi",
    },
    call_ended_hint: {
        sv: "Du kan stänga den här sidan.",
        en: "You can close this page.",
        no: "Du kan lukke denne siden.",
        da: "Du kan lukke denne side.",
        fi: "Voit sulkea tämän sivun.",
    },
    back: {
        sv: "Tillbaka",
        en: "Back",
        no: "Tilbake",
        da: "Tilbage",
        fi: "Takaisin",
    },
    err_invalid_title: {
        sv: "Länken fungerar inte längre",
        en: "This link no longer works",
        no: "Lenken virker ikke lenger",
        da: "Linket virker ikke længere",
        fi: "Linkki ei enää toimi",
    },
    err_invalid_body: {
        sv: "Kontakta personalen på boendet för en ny länk.",
        en: "Contact the care home staff for a new link.",
        no: "Kontakt personalet for en ny lenke.",
        da: "Kontakt personalet for et nyt link.",
        fi: "Pyydä henkilökunnalta uusi linkki.",
    },
    err_network_title: {
        sv: "Ingen anslutning",
        en: "No connection",
        no: "Ingen tilkobling",
        da: "Ingen forbindelse",
        fi: "Ei yhteyttä",
    },
    err_network_body: {
        sv: "Kontrollera din internetanslutning och försök igen.",
        en: "Check your internet connection and try again.",
        no: "Sjekk internettforbindelsen og prøv igjen.",
        da: "Tjek din internetforbindelse og prøv igen.",
        fi: "Tarkista internetyhteytesi ja yritä uudelleen.",
    },
    retry: {
        sv: "Försök igen",
        en: "Try again",
        no: "Prøv igjen",
        da: "Prøv igen",
        fi: "Yritä uudelleen",
    },
    notif_title: {
        sv: "Missa inte när det ringer",
        en: "Don't miss a call",
        no: "Ikke gå glipp av et anrop",
        da: "Gå ikke glip af et opkald",
        fi: "Älä missaa puhelua",
    },
    notif_why: {
        sv: "Sätt på aviseringar så att du hör när {name} ringer, även när sidan är stängd.",
        en: "Turn on notifications so you hear when {name} calls, even when this page is closed.",
        no: "Slå på varsler så du hører når {name} ringer, også når siden er lukket.",
        da: "Slå notifikationer til, så du hører når {name} ringer, også når siden er lukket.",
        fi: "Ota ilmoitukset käyttöön, jotta kuulet kun {name} soittaa, vaikka sivu olisi suljettu.",
    },
    notif_why_generic: {
        sv: "Sätt på aviseringar så att du hör när rummet ringer, även när sidan är stängd.",
        en: "Turn on notifications so you hear when the room calls, even when this page is closed.",
        no: "Slå på varsler så du hører når rommet ringer, også når siden er lukket.",
        da: "Slå notifikationer til, så du hører når stuen ringer, også når siden er lukket.",
        fi: "Ota ilmoitukset käyttöön, jotta kuulet kun huoneesta soitetaan, vaikka sivu olisi suljettu.",
    },
    notif_enable: {
        sv: "Sätt på aviseringar",
        en: "Turn on notifications",
        no: "Slå på varsler",
        da: "Slå notifikationer til",
        fi: "Ota ilmoitukset käyttöön",
    },
    notif_later: {
        sv: "Inte nu",
        en: "Not now",
        no: "Ikke nå",
        da: "Ikke nu",
        fi: "Ei nyt",
    },
    notif_on: {
        sv: "Aviseringar är på. Du blir uppringd här.",
        en: "Notifications are on. Calls will reach you here.",
        no: "Varsler er på. Anrop når deg her.",
        da: "Notifikationer er slået til. Opkald når dig her.",
        fi: "Ilmoitukset ovat päällä. Puhelut tavoittavat sinut täällä.",
    },
    notif_denied: {
        sv: "Aviseringar är avstängda. Du kan slå på dem i telefonens inställningar.",
        en: "Notifications are off. You can turn them on in your phone's settings.",
        no: "Varsler er av. Du kan slå dem på i telefonens innstillinger.",
        da: "Notifikationer er slået fra. Du kan slå dem til i telefonens indstillinger.",
        fi: "Ilmoitukset ovat pois päältä. Voit ottaa ne käyttöön puhelimen asetuksista.",
    },
    install_title: {
        sv: "Lägg till på hemskärmen",
        en: "Add to your home screen",
        no: "Legg til på hjemskjermen",
        da: "Føj til hjemmeskærmen",
        fi: "Lisää aloitusnäytölle",
    },
    install_ios_steps: {
        sv: 'Tryck på Dela-knappen nedtill och välj "Lägg till på hemskärmen". Då kan telefonen ge ljud när {name} ringer.',
        en: 'Tap the Share button below and choose "Add to Home Screen". Then your phone can ring when {name} calls.',
        no: 'Trykk på Del-knappen nederst og velg "Legg til på Hjem-skjerm". Da kan telefonen ringe når {name} ringer.',
        da: 'Tryk på Del-knappen nederst, og vælg "Føj til hjemmeskærm". Så kan telefonen ringe, når {name} ringer.',
        fi: 'Napauta alareunan Jaa-painiketta ja valitse "Lisää aloitusnäytölle". Silloin puhelin voi soida kun {name} soittaa.',
    },
    install_ios_steps_generic: {
        sv: 'Tryck på Dela-knappen nedtill och välj "Lägg till på hemskärmen". Då kan telefonen ge ljud när rummet ringer.',
        en: 'Tap the Share button below and choose "Add to Home Screen". Then your phone can ring when the room calls.',
        no: 'Trykk på Del-knappen nederst og velg "Legg til på Hjem-skjerm". Da kan telefonen ringe når rommet ringer.',
        da: 'Tryk på Del-knappen nederst, og vælg "Føj til hjemmeskærm". Så kan telefonen ringe, når stuen ringer.',
        fi: 'Napauta alareunan Jaa-painiketta ja valitse "Lisää aloitusnäytölle". Silloin puhelin voi soida kun huoneesta soitetaan.',
    },
    dismiss: {
        sv: "Stäng",
        en: "Dismiss",
        no: "Lukk",
        da: "Luk",
        fi: "Sulje",
    },
    privacy: {
        sv: "Om integritet",
        en: "About privacy",
        no: "Om personvern",
        da: "Om privatliv",
        fi: "Tietosuoja",
    },
    privacy_text: {
        sv: "Kameran på rummets TV är avstängd tills samtalet besvaras. Bilden spelas aldrig in.",
        en: "The camera on the room's TV is off until a call is answered. Video is never recorded.",
        no: "Kameraet på rommets TV er av til et samtale besvares. Videoen tas aldri opp.",
        da: "Kameraet på stuens TV er slukket, indtil et opkald besvares. Video optages aldrig.",
        fi: "Huoneen TV:n kamera on pois päältä, kunnes puheluun vastataan. Kuvaa ei koskaan tallenneta.",
    },
};
export function makeT(locale) {
    return (key, vars) => {
        var _a, _b, _c;
        const map = RELATIVE_STRINGS[key];
        let text = (_c = (_b = (_a = map[locale]) !== null && _a !== void 0 ? _a : map[FALLBACK_LOCALE]) !== null && _b !== void 0 ? _b : map.en) !== null && _c !== void 0 ? _c : key;
        if (vars) {
            for (const [k, v] of Object.entries(vars)) {
                text = text.replace(new RegExp(`\\{${k}\\}`, "g"), v);
            }
        }
        return text;
    };
}
export function svPossessive(name) {
    const trimmed = name.trim();
    if (!trimmed)
        return trimmed;
    return /[sxzSXZ]$/.test(trimmed) ? trimmed : `${trimmed}s`;
}
